import { render, staticRenderFns } from "./SalesByTicketBlockModal.vue?vue&type=template&id=00424bb1"
import script from "./SalesByTicketBlockModal.vue?vue&type=script&lang=js"
export * from "./SalesByTicketBlockModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports